function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-fire-danger-ratings_svg__icon-fire-danger-ratings_svg__clip0_7332_45175)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.827 29.917h-.03l.015.016.015-.016z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 29.917h20.024L5.89 15.106C2.26 18.892.011 24.129 0 29.917z",
  fill: "#33C203"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 29.917c-.01-5.767-2.244-10.987-5.85-14.77l-14.095 14.77H40z",
  fill: "#BF0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.039 9h-.04c-5.506 0-10.493 2.332-14.11 6.106l14.135 14.811h.015V9z",
  fill: "#FFDE00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.04 9v20.917h.014l14.095-14.77C30.54 11.358 25.55 9.011 20.04 9z",
  fill: "#FF7A03"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 27.178c-1.488 0-2.693 1.263-2.693 2.822h5.386c0-1.559-1.206-2.822-2.693-2.822z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-fire-danger-ratings_svg__icon-fire-danger-ratings_svg__clip0_7332_45175"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 9)",
  d: "M0 0h40v21H0z"
})));

function SvgIconFireDangerRatings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzczMzJfNDUxNzUpIj4KPHBhdGggZD0iTTIwLjgyNyAyOS45MTdIMjAuODExOUgyMC43OTY5TDIwLjgxMTkgMjkuOTMyOEwyMC44MjcgMjkuOTE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTAgMjkuOTE3SDIwLjAyNDJMNS44OTAwMiAxNS4xMDU4QzIuMjYwNjQgMTguODkxNiAwLjAxMTA4OTMgMjQuMTI5MSAwIDI5LjkxN1oiIGZpbGw9IiMzM0MyMDMiLz4KPHBhdGggZD0iTTQwLjAwMDQgMjkuOTE3QzM5Ljk4OTMgMjQuMTQ5OSAzNy43NTY0IDE4LjkyOTggMzQuMTUgMTUuMTQ2NEwyMC4wNTQ3IDI5LjkxN0g0MC4wMDA0WiIgZmlsbD0iI0JGMDAwMCIvPgo8cGF0aCBkPSJNMjAuMDM4OCA5QzIwLjAyNTQgOSAyMC4wMTI3IDkgMTkuOTk5MiA5QzE0LjQ5MjYgOSA5LjUwNjM1IDExLjMzMjQgNS44ODk2NSAxNS4xMDU4TDIwLjAyMzggMjkuOTE3SDIwLjAzODhWOVoiIGZpbGw9IiNGRkRFMDAiLz4KPHBhdGggZD0iTTIwLjAzOTEgOVYyOS45MTdIMjAuMDU0MUwzNC4xNDk0IDE1LjE0NjRDMzAuNTM4MyAxMS4zNTkgMjUuNTUwNSA5LjAxMTYyIDIwLjAzOTEgOVoiIGZpbGw9IiNGRjdBMDMiLz4KPHBhdGggZD0iTTE5Ljk5OTggMjcuMTc3OUMxOC41MTIyIDI3LjE3NzkgMTcuMzA2NiAyOC40NDEyIDE3LjMwNjYgMzBIMjIuNjkyOUMyMi42OTI5IDI4LjQ0MTIgMjEuNDg3MyAyNy4xNzc5IDE5Ljk5OTggMjcuMTc3OVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzMzMl80NTE3NSI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSIyMSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgOSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgIconFireDangerRatings as ReactComponent };